module.exports = __webpack_public_path__ + "img/gauge-2.7e4bbc37.svg";